module.exports = __webpack_public_path__ + "img/img-a2838482.57dca916.png";